$(document).ready( function() {
    initMobile();
    changeToCross($('.fs-header.mobile .hamburger svg'));
    changeToBurg($('.fs-header.mobile .hamburger svg'));
});

function initMobile() {
    $('.fs-header.mobile .product').click( function() {
        console.log('hello click');
    })

    initHamburger();
}

function initHamburger() {
    $('.fs-header.mobile .hamburger').click( function() {
        $('.fs-header.mobile').toggleClass('active');
        if ($('.fs-header.mobile').hasClass('active')) {
            changeToCross($(this).find('svg'));
            return;
        }
        changeToBurg($(this).find('svg'));
    })
}

function changeToCross(elem) {
    elem.width('17.3');
    elem.height('13.8');
    elem.attr('viewBox', '0 0 17.3 13.8');
    elem.find('g').attr('transform', 'translate(-22.1 -31.956)');
    elem.find('#Line_57').attr('transform', 'translate(23.5 33.5)');
    elem.find('#Line_57').attr('x2', '14.5');
    elem.find('#Line_57').attr('y2', '10.855');
    elem.find('#Line_59').attr('transform', 'translate(23.5 33.355)');
    elem.find('#Line_59').attr('x2', '14.5');
    elem.find('#Line_59').attr('y1', '10.855');
    elem.find('#Line_58').hide();
}

function changeToBurg(elem) {
    elem.width('16.775');
    elem.height('12.711');
    elem.attr('viewBox', '0 0 16.775 12.711');
    elem.find('g').attr('transform', 'translate(-22.5 -32.5)');
    elem.find('#Line_57').attr('transform', 'translate(23.5 33.5)');
    elem.find('#Line_57').attr('x2', '14.775');
    elem.find('#Line_57').attr('y2', '0');
    elem.find('#Line_59').attr('transform', 'translate(23.5 44.211)');
    elem.find('#Line_59').attr('x2', '14.775');
    elem.find('#Line_59').attr('y1', '0');
    elem.find('#Line_58').show();
}